// eslint-disable-next-line no-unused-expressions
import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ModuleSkeleton = () => {
  return (
    <>
      <SkeletonTheme baseColor="#202020" highlightColor="#444">
        <div className=" my-3">
          <div  className="p-2 py-3 bg-Color d-flex mb-3 ">

            <div className="col-md-6">
              <Skeleton className="mt-0 ms-2 MTS23"  />
            </div>
            <div className="col-md-6">
              <Skeleton className="mt-0 ms-2 MTS23" />
            </div>

          </div>
        </div>
      </SkeletonTheme>
    </>
  );
};

export default ModuleSkeleton;
